import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import sv from 'vuetify/lib/locale/sv';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { sv },
    current: 'sv',
  },
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#47CB87',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
      },
    },
  },
});
